import { render, staticRenderFns } from "./FormHotAlertContactStatus.vue?vue&type=template&id=74864ea2&"
import script from "./FormHotAlertContactStatus.vue?vue&type=script&lang=js&"
export * from "./FormHotAlertContactStatus.vue?vue&type=script&lang=js&"
import style0 from "./FormHotAlertContactStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports